import React from 'react';
import {OverlayTrigger, Popover} from "react-bootstrap";

export function TermWrapper(props) {

    if(props.term != null) {
        const popover = (
            <Popover id={"popover-basic"} show={false}>
                <Popover.Header className={"bg-primary text-white"}>
                    {props.term.term}
                </Popover.Header>
                <p className={"p-3"}>
                    {props.term.definition}
                </p>
            </Popover>
        );

        return (
            <span>

            <OverlayTrigger trigger={["hover", "focus", "click"]} overlay={popover} placement={"top"} defaultShow={false}>
                <span className={"clickable course-term text-decoration-underline"}>{props.children}</span>
            </OverlayTrigger>
        </span>

        );
    } else {
        return (
            <>{props.children}</>
        );
    }


}


